import { useEffect, useState } from "react";

import { PaymentsPayoutService, PayoutStatus } from "../services/payoutRescue.service";

/**
 * Stuck-`CREATED` count for the sidebar badge. Fetched ONCE when the sidebar mounts (acceptance criterion: no
 * background polling — the count may go stale until the next full page load, by design). Failures are silent:
 * the badge simply doesn't render. Callers must pass `enabled=false` for non-INTERNAL users so an org member
 * never triggers a call that would 403 (they don't see the menu item anyway).
 */
export const usePayoutRescueBadge = (enabled: boolean): number | null => {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    PaymentsPayoutService.listPayouts({ status: PayoutStatus.CREATED, limit: 1 })
      .then((res) => {
        if (!cancelled) setCount(res.data.total);
      })
      .catch(() => {
        // Silent — the badge is an enhancement, never a blocker.
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return count;
};
